const parseChainId = (chainId) => parseInt(chainId.toString());

export { parseChainId };
